export const MOBILE_WIDTH = 480;
export const PILGRIM_TOP_MENU_HEIGHT = 56;
export const EDITOR_COMPACT_WIDTH = 1200;
export const AUTOCOMPLETE_DROPDOWN_SIZE = 30;
export const SIDEBAR_WIDTH = 64;
